<template>
  <div class="col-md-4 col-xs-12">
    <div class="bg-blue-grey-100 admin-package-box p-30 font-size-14 clearfix" v-if="showPricingPlanForm">
      <form autocomplete="off" v-on:submit.prevent="onSubmitPricingPlanForm">
        <div class="row">
          <form-group formGroupClass="form-group col-md-12" v-bind:error="formErrors.first('pricingPlan')">
            <label for="role" class="form-control-label">Change Pricing Plan</label>
            <select class="form-control" id="pricingPlan" v-model="currentPricingPlan.alias">
              <option
                v-for="(pricingPlan, index) in pricingPlanList"
                v-bind:value="pricingPlan.alias">
                {{pricingPlan.name}}
              </option>
            </select>
          </form-group>
        </div>
        <div class="row">
          <div class="col-md-6">
            <button type="submit" class="btn btn-success pull-xs-left">
              Update Plan
            </button>
          </div>
          <div class="col-md-6">
            <button type="button" class="btn btn-link pull-xs-right" v-on:click="cancelPricingPlanForm">
              Cancel
            </button>
          </div>
        </div>
      </form>
    </div>
    <div class="bg-blue-grey-100 admin-package-box  p-30 font-size-14" v-else>
      <div class="counter counter-md text-xs-left">
        <div class="counter-label text-ca m-b-5">Pricing Plan Setting</div>
        <span class="counter-number">{{currentPricingPlan.name}}
        </span>
        <div class="counter-label m-b-5 m-t-20">Click for more detail <router-link v-bind:to="`/`" target="_blank">Pricing</router-link></div>
        <!--div class="counter-label m-b-5">Last added: 1 Mar 2017 20:05</div-->
        <div class="counter-label text-uppercase m-b-5 m-t-20">
          <button
            type="button"
            class="btn btn-primary"
            v-if="!team.has_reseller"
            v-on:click="togglePricingPlanForm">Change plan
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { Validator } from 'vee-validate';
import Alert from 'components/Alert';
import FormGroup from 'components/forms/FormGroup';

export default {
  components: {
    Alert,
    FormGroup,
  },
  props: {
    team: {
      type: Object,
    },
  },
  watch: {
    team: function(value) {
      if (value) {
        this.fetchPricingPlanList();
      }
    },
    'currentPricingPlan.alias': function(value) {
      const pricingPlan = this.pricingPlanList.find((item) => {
        if (item.alias === value) {
          return item;
        }
      });

      if (pricingPlan) {
        this.currentPricingPlan.name = pricingPlan.name;
      }
    },
  },
  created: function() {
    this.isLoading = true;

    this.$emit('loadChanged', true);

    this.validator = new Validator();
    this.validator.attach('pricingPlan', 'required', { prettyName: 'pricing plan' });

    this.$set(this, 'formErrors', this.validator.errorBag);
  },
  mounted: function() {
    if (this.team) {
      this.fetchPricingPlanList();
    }
  },
  computed: {
    baseURL: function() {
      return process.env.BASE_URL;
    },
  },
  data: function() {
    return {
      isLoading: false,
      validator: null,
      formErrors: null,
      showAlert: false,
      errorResponse: null,
      showPricingPlanForm: false,
      currentPricingPlan: {
        name: null,
        alias: null,
      },
      pricingPlanList: null,
    };
  },
  methods: {
    fetchPricingPlanList: function() {
      axios.get(`/api/pricingplans`)
      .then((response) => {
        this.pricingPlanList = response.data.plans;
        this.currentPricingPlan.alias = this.team.pricing_plan;

        this.isLoading = false;

        this.$emit('loadChanged', false);
      })
      .catch(() => {
        this.isLoading = false;

        this.$emit('loadChanged', false);
      });
    },
    onSubmitPricingPlanForm: function() {
      // hide alert
      this.showAlert = false;

      this.validator.validateAll({
        pricingPlan: this.currentPricingPlan.alias,
      })
      .then(() => {
        return this.updatePricingPlan(this.currentPricingPlan.alias);
      })
      .then(() => {
        this.showAlert = false;

        this.team.pricing_plan = this.currentPricingPlan.alias;

        this.togglePricingPlanForm();
      })
      .catch(() => {
        this.showAlert = true;
        this.errorResponse = this.$t('admin.billing.pricingplan.response.failed');
      });
    },
    togglePricingPlanForm: function() {
      this.showPricingPlanForm = !this.showPricingPlanForm;
    },
    cancelPricingPlanForm: function() {
      this.currentPricingPlan.alias = this.team.pricing_plan;
      this.togglePricingPlanForm();
    },
    updatePricingPlan: function(pricingPlan) {
      return axios.post(`/api/teams/${this.team.namespace}/pricingplan`, {
        pricing_plan: pricingPlan,
      });
    },
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// PricingPlan.vue?8b86525c